module.exports = __webpack_public_path__ + "media/images/sign_up_background_small-70395e6507095608c93277863b0df69a.png";